module.exports = __webpack_public_path__ + "images/application/templates/billing@2x-9226ae00.png";